var RulesJS = RulesJS || {};

RulesJS.CollectionListPaginatorSwiper = function() {

    var _initialized = false;
    var _swipers = [];

    var _selectors = {
        swiper: '.swiper--collection-list-paginator'
    };

    var _defaults = {
        autoplay: {
            delay:                  3000,
            disableOnInteraction:   false,
            pauseOnMouseEnter:      true,
        },
        effect:                 'slide',
        loop:                   true,
        pagination:             '.swiper-pagination',
        paginationType:         'bullets',
        slides:                 1,
        spacing:                0,
    };

    var _init = function() {

        $(_selectors.swiper).each(function() {
            _initSwiper($(this));
        });

        _handleShopifyDesignModeEvents();

        if (!_initialized) {
            _initialized = true;
        }
    }

    var _handleShopifyDesignModeEvents = function() {
        if (Shopify.designMode) {

            $(document).on('shopify:section:load', function(e) {
                $('#shopify-section-' + e.detail.sectionId + ' ' + _selectors.swiper).each(function() {
                    _initSwiper($(this));
                });
            });


            $(document).on('shopify:block:select', function(e) {
                $('#shopify-section-' + e.detail.sectionId + ' ' + _selectors.swiper).each(function() {
                    let swiper = $(this);
                    let slide = swiper.find('.swiper-slide[data-shopify-block-id="' + e.detail.blockId + '"]');
                    if (slide.length) {
                        swiper[0].swiper.slideTo(swiper.find('.swiper-slide').index(slide));
                        swiper[0].swiper.disable();
                        return false;
                    }
                });
            });

            $(document).on('shopify:block:deselect', function(e) {
                if (e.target.matches('.swiper-slide')) {
                    $('#shopify-section-' + e.detail.sectionId + ' ' + _selectors.swiper).each(function() {
                        let swiper = $(this);
                        let slide = swiper.find('.swiper-slide[data-shopify-block-id="' + e.detail.blockId + '"]');
                        if (slide.length) {
                            swiper[0].swiper.enable();
                            return false;
                        }
                    });
                }
            });

        }
    }

    var _initSwiper = function(el) {
        let swiperConfig = {};

        // straightforward settings
        swiperConfig.loop = typeof el.data('swpr-loop') !== 'undefined' ? el.data('swpr-loop') : _defaults.loop;
        swiperConfig.slidesPerView = el.data('swpr-slides') || _defaults.slides;
        swiperConfig.spaceBetween = el.data('swpr-spacing') || _defaults.spacing;

        // swiper animation effect
        let effectType = el.data('swpr-effect');
        if (effectType) {
            switch (effectType) {
                case 'fade':
                    swiperConfig.effect = 'fade';
                    swiperConfig.fadeEffect = {
                        crossFade: true
                    }
                    break;
            }
        }

        // swiper breakpoints
        let breakpoints = {
            0: {slidesPerView: el.data('swpr-xs-slides') || el.data('swpr-slides') || _defaults.slides, spaceBetween: el.data('swpr-xs-spacing') || el.data('swpr-spacing') || _defaults.spacing},
            576: {slidesPerView: el.data('swpr-sm-slides') || el.data('swpr-slides') || _defaults.slides, spaceBetween: el.data('swpr-sm-spacing') || el.data('swpr-spacing') || _defaults.spacing},
            768: {slidesPerView: el.data('swpr-md-slides') || el.data('swpr-slides') || _defaults.slides, spaceBetween: el.data('swpr-md-spacing') || el.data('swpr-spacing') || _defaults.spacing},
            992: {slidesPerView: el.data('swpr-lg-slides') || el.data('swpr-slides') || _defaults.slides, spaceBetween: el.data('swpr-lg-spacing') || el.data('swpr-spacing') || _defaults.spacing},
            1200: {slidesPerView: el.data('swpr-xl-slides') || el.data('swpr-slides') || _defaults.slides, spaceBetween: el.data('swpr-xl-spacing') || el.data('swpr-spacing') || _defaults.spacing},
            1400: {slidesPerView: el.data('swpr-xxl-slides') || el.data('swpr-slides') || _defaults.slides, spaceBetween: el.data('swpr-xxl-spacing') || el.data('swpr-spacing') || _defaults.spacing}
        };
        swiperConfig.breakpoints = breakpoints;

        // swiper allow touch move
        if (el.data('allow-touch-move') === false) {
            swiperConfig.allowTouchMove = false;
        }

        // swiper autoplay
        let autoplay = _defaults.autoplay;
        if (el.data('swpr-autoplay') === false) {
            autoplay = false;
        } else {
            if (el.data('swpr-autoplay-delay')) {
                autoplay.delay = el.data('swpr-autoplay-delay');
            }
        }
        swiperConfig.autoplay = autoplay;

        // event callbacks
        let callbacks = {
            activeIndexChange: function(swiper) {
                $.publish('ValueJSSwiper.activeIndexChange', [el]);
                $(swiper.el)
                    .parents('.section')
                    .find('.swiper--collection-list')[0]
                    .swiper.slideTo(swiper.activeIndex);
            },
            afterInit: function(swiper) {
                $.publish('ValueJSSwiper.afterInit', [el]);
                // animate active slides
                // el.find('.swiper-slide-active [data-anim-fx]').each(function(){
                //     ValueJS.AnimateCSS.animate($(this));
                // });
                // reset animation on non-visible slides
                el.find('.swiper-slide:not(.swiper-slide-active) .animate__animated').each(function(){
                    ValueJS.AnimateCSS.reset($(this));
                });
            },
            transitionStart: function(swiper) {
                $.publish('ValueJSSwiper.transitionStart', [el]);
                // reset animation on non-visible slides
                // el.find('.swiper-slide:not(.swiper-slide-active) .animate__animated').each(function(){
                //     ValueJS.AnimateCSS.reset($(this));
                // });
            },
            transitionEnd: function(swiper) {
                $.publish('ValueJSSwiper.transitionEnd', [el]);
                // animate active slides
                // el.find('.swiper-slide-active [data-anim-fx]').each(function(){
                //     ValueJS.AnimateCSS.animate($(this));
                // });
                // update collection list swiper
            }
        }
        swiperConfig.on = callbacks;

        // swiper navigation
        let navigation = false;
        if (el.data('next-btn') && el.data('prev-btn')) {
            navigation = {
                nextEl: el.data('next-btn'),
                prevEl: el.data('prev-btn'),
                disabledClass: 'op-3'
            }
        }
        swiperConfig.navigation = navigation;

        // swiper no swiping
        if (el.data('no-swiping')) {
            swiperConfig.noSwiping = true;
            swiperConfig.noSwipingClass = el.data('no-swiping');
        }

        // swiper pagination
        let pagination = false;
        if (el.data('pagination')) {
            pagination = {
                el: el.data('pagination'),
                clickable: true,
                type: 'bullets',
            }
        }
        swiperConfig.pagination = pagination;

        // thumbs
        swiperConfig.thumbs = {
            swiper: el.parents('.section').find('.swiper--collection-list-paginator')[0].swiper
        }

        // init swiper
        let swiper = new Swiper(el[0], swiperConfig);

    }

    var _domUpdate = function() {
        _swipers.forEach(function(swiper) {
            _swiper.destroy();
        });
        _swipers = [];
        _init();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    RulesJS.CollectionListPaginatorSwiper.init();
});